import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './App.css';
import { LenisProvider } from './lenis/LenisProvider.jsx';
import { PageTransitionProvider } from './transitions/PageTransition.jsx';
import CustomCursor from './components/CustomCursor/CustomCursor.tsx';
import ScrollProgress from './components/ScrollProgress/ScrollProgress.tsx';
import Header from './components/Header.tsx';
import Footer from './components/Footer/Footer.tsx';
import Home from './layers/Home/Home.tsx'
import Project from './layers/Project/Project.tsx';
import Cv from './layers/CV/Cv.tsx';

function App() {
  return (
    <div className="App">
      <CustomCursor />
      <ScrollProgress />
      <BrowserRouter>
        <LenisProvider>
          <PageTransitionProvider>
            <Header />
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/project/:id' element={<Project />} />
              <Route path='/cv' element={<Cv />} />
              <Route path='*' element={<h1>Not Found</h1>} />
            </Routes>
            <Footer />
          </PageTransitionProvider>
        </LenisProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
